<template>
    <div>
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入标题/房间名搜索"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template #publishStatus="{ row }">
                <i-switch
                    v-model="row.publishStatus"
                    true-value="1"
                    false-value="0"
                    @on-change="onPublishStatusChange(row, $event)"
                ></i-switch>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                    >详情</Button
                >
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        >
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showInformation"
            :title="actionTitle + '通知'"
            :width="800"
            :height="420"
            :maskClosable="false"
            :buttons.sync="formBtns"
            @close-by-confirm="search"
        >
            <i-msg-form
                v-if="modal.showInformation"
                :formMode="formMode"
                :defaultValue="curRow"
            ></i-msg-form>
        </smart-modal>
    </div>
</template>
<script>
import Dict from '_u/dict'
import { mapCache } from '@/plugins/vux-data-cache'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import { msgHistoryList } from '@/api/notify'
import mList from '_v/common/m-list'
import iMsgForm from './i-msg-form'

export default {
    name: 'iMsgRecord',
    mixins: [mList],
    components: {
        iMsgForm,
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            page: {
                total: 0,
                list: [],
            },
            dict: {
                publicNotifyType: Dict.NULL,
            },
            modal: {
                showInformation: false,
            },
            curId: '',
            curRow: null,
            formBtns: [],
        }
    },

    computed: {
        ...mapCache({
            filter: 'recordFilter',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'title',
                    title: '通知标题',
                    align: 'left',
                    minWidth: 140,
                },
                {
                    key: 'houseNameAgg',
                    title: '发布房间',
                    align: 'left',
                    minWidth: 280,
                    ellipsis: true,
                },
                {
                    key: 'createUserName',
                    title: '操作人',
                    align: 'left',
                    minWidth: 80,
                },
                {
                    key: 'createTime',
                    title: '发布时间',
                    align: 'left',
                    width: 160,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed: 'right',
                    slot: 'action',
                },
            ]
        },
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            return Promise.all([
                Dict.get(['public_notify_type']),
                msgHistoryList(this.filter),
            ])
                .then((args) => {
                    var [dictGroup, page] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        setPageData(data) {
            var list = data.page.list

            list.forEach((v) => {
                var notifyInfo = v.notifyInfo,
                    createUser = v.createUser
                v.title = notifyInfo.title // 标题
                v.content = notifyInfo.content // 内容
                v.createUserName = createUser.nickname // 操作人
            })
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
        rowClickView(row) {
            this.formMode = this.FORM_MODE.view
            this.curRow = row
            this.modal.showInformation = true
        },
    },
}
</script>
<style lang="less" scoped></style>
